import { useState, useRef, useEffect } from "react";
import { IconReport, IconHint } from "../elements/Icon2";

export default function ReportSection({ loading, reportData, onClose }) {
    const modalRef = useRef(null);
    const [clickedSection, setClickedSection] = useState([]);
    const [clickedSubSection, setClickedSubSection] = useState([]);

    const extractFinalData2 = (obj) => {
        while (obj && !obj.result) {
            const keys = Object.keys(obj);
            if (!keys.length) return null;
            obj = obj[keys[0]];
        }
        return obj;
    };

    const sections = Object.keys(reportData || {}).map((section) => {
        const subSections = Object.keys(reportData[section] || {});
        let totalRight = 0;
        let totalWrong = 0;

        subSections.forEach((subSection) => {
            const dataObj = reportData[section]?.[subSection];
            const data = extractFinalData2(dataObj);
            if (!data || !data.result) return;

            totalRight += data.result.right || 0;
            totalWrong += data.result.wrong || 0;
        });

        return {
            name: section,
            totalRight,
            totalWrong
        };
    }).filter(section => section.totalRight + section.totalWrong > 0);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    if (!reportData) return null;


    const extractFinalData = (obj) => {
        if (!obj) return null;
        if (obj.result && obj.history) return obj;
        const firstKey = Object.keys(obj)[0];
        return extractFinalData(obj[firstKey]);
    };

    return (
        <div
            className="fixed inset-0 bg-black/50 flex items-center justify-center z-[200]"
            onClick={onClose}
        >
            <div
                ref={modalRef}
                className="bg-white w-[1000px] max-h-[90vh] rounded-[20px] overflow-auto p-[20px]"
                onClick={(e) => e.stopPropagation()}
            >



                {loading && <div>Loading...</div>}

                {!loading &&
                    sections.map(({ name, totalRight, totalWrong }) => {
                        const subSections = Object.keys(reportData[name] || {});


                        const totalPercent =
                            totalRight + totalWrong
                                ? Math.round((totalRight / (totalRight + totalWrong)) * 100)
                                : 0;
                        const color =
                            totalPercent < 20
                                ? "#F34F25"
                                : totalPercent < 80
                                    ? "#F3A125"
                                    : "#7DAE43";
                        return (
                            <div key={name} className="mb-[10px]">
                                <table className="w-full table-fixed">
                                    <tr onClick={() =>
                                        setClickedSection(prev => ({
                                            ...prev,
                                            [name]: !prev[name]
                                        }))
                                    }
                                        className="w-1/3 font-bold text-[#F3A125] text-[20px] bg-[#F2F5F6] cursor-pointer">
                                        <td
                                            className="uppercase cursor-pointer "

                                        >
                                            ▼ {name}
                                        </td>

                                        <td className="w-1/3 text-center">
                                            {totalRight}/{totalRight + totalWrong}</td>

                                        <td className="w-1/3 ">

                                            <div className="flex items-center justify-end gap-1">
                                                <span>{totalPercent}%</span>
                                                <IconReport
                                                    color={color}
                                                    className="w-[15px] h-[15px]"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </table>



                                {/* SUBSECTIONS */}
                                {clickedSection[name] &&
                                    subSections.map((subSection) => {
                                        const dataObj = reportData[name]?.[subSection];
                                        const data = extractFinalData(dataObj);
                                        if (!data) return null;

                                        const right = data.result?.right || 0;
                                        const wrong = data.result?.wrong || 0;
                                        const percent =
                                            right + wrong
                                                ? Math.round((right / (right + wrong)) * 100)
                                                : 0;

                                        const color =
                                            percent < 20
                                                ? "#F34F25"
                                                : percent < 80
                                                    ? "#F3A125"
                                                    : "#7DAE43";

                                        return (
                                            <div key={subSection} className="ml-[10px] ">

                                                {/* SUBSECTION HEADER */}
                                                <table className="w-full table-fixed">
                                                    <tr
                                                        onClick={() =>
                                                            setClickedSubSection(prev => ({
                                                                ...prev,
                                                                [name + "_" + subSection]:
                                                                    !prev[name + "_" + subSection]
                                                            }))
                                                        }
                                                        className="font-bold cursor-pointer ">
                                                        <td
                                                            className="uppercase w-1/3"

                                                        >
                                                            ▼ {subSection.replaceAll("_", " ")}
                                                        </td>

                                                        <td className="w-1/3 text-center">
                                                            {`${right}/${right + wrong}`}</td>

                                                        <td className="w-1/3 ">

                                                            <div className="flex items-center justify-end gap-1">
                                                                <span>{percent}%</span>
                                                                <IconReport
                                                                    color={color}
                                                                    className="w-[15px] h-[15px]"
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>

                                                {/* TABLE */}
                                                {clickedSubSection[name + "_" + subSection] && (
                                                    <table className="w-full text-center table-fixed border-collapse">
                                                        <thead>
                                                            <tr className="text-[#F4A100]">
                                                                <th className="py-2">Question</th>
                                                                <th>Student Answer</th>
                                                                <th>Correct</th>
                                                                <th>Hint Used</th>
                                                                <th>Result</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Object.entries(data.history).map(
                                                                ([entry, result], index) => {
                                                                    const [question, answer] = entry.split("=");

                                                                    return (
                                                                        <tr key={index} className="border-t">
                                                                            <td className="py-2">{question}</td>

                                                                            <td>
                                                                                {(() => {
                                                                                    const match = answer.toString().match(/\[([^\]]+)\]/);
                                                                                    if (match) {
                                                                                        return match[1];
                                                                                    } else {
                                                                                        return answer;
                                                                                    }
                                                                                })()}
                                                                            </td>

                                                                            <td>
                                                                                {(() => {
                                                                                    if (typeof answer === "string") {
                                                                                        const match = answer.match(/\[([^\]]+)\]/);

                                                                                        if (match) {
                                                                                            const arr = match[1].split(",").map(el => el.trim());
                                                                                            return result ? arr[arr.length-1] : "?";
                                                                                        }
                                                                                    }

                                                                                    return answer;
                                                                                })()}

                                                                            </td>

                                                                            <td className="text-center align-middle">
                                                                                {answer && answer.toString().includes("hint") && (
                                                                                    <IconHint className="inline-block w-[20px] h-[20px] mx-auto" />
                                                                                )}
                                                                            </td>

                                                                            <td>
                                                                                {result ? (
                                                                                    <span className="text-green-500 font-bold">✓</span>
                                                                                ) : (
                                                                                    <span className="text-red-500 font-bold">✕</span>
                                                                                )}
                                                                            </td>

                                                                        </tr>
                                                                    );
                                                                }
                                                            )}
                                                        </tbody>
                                                    </table>
                                                )}
                                            </div>
                                        );
                                    })}
                            </div>
                        );
                    })}
            </div>
        </div >
    );
}